import { logFeature } from '@office-start/telemetry-service';
export var logSchedulerMetrics = function (_a) {
    var appId = _a.appId, scenarioName = _a.scenarioName, _b = _a.priority, priority = _b === void 0 ? 0 : _b;
    logFeature({
        featureName: "Scheduler" /* KnownFeatureNames.Scheduler */,
        eventName: "Scheduler" /* KnownFeatureInstrumentationEvents.Scheduler */,
        params: {
            AppId: appId,
            MOSHubScenarioName: scenarioName,
            Priority: priority,
        },
        area: 'Scheduler',
        subArea: 'SchedulerMetrics',
    });
};
//# sourceMappingURL=logSchedulerMetrics.js.map